import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import Logo from '../assets/logo/logo.png';

const links = [
  ['Products', '/#products'],
  ['How It Works', '/#how-it-works'],
  ['About', '/#about'],
];

const SiteHeader = () => {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <header className="site-header">
      <nav className="site-nav" aria-label="Primary navigation">
        <Link className="brand" to="/" onClick={close} aria-label="Jupiter Cosmic — Home">
          <img src={Logo} alt="" />
          <span>Jupiter Cosmic</span>
        </Link>
        <button
          className="menu-toggle"
          type="button"
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          aria-controls="primary-links"
          onClick={() => setOpen((value) => !value)}
        >
          {open ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
        </button>
        <div id="primary-links" className={`nav-links${open ? ' is-open' : ''}`}>
          {links.map(([label, to]) => <Link key={to} to={to} onClick={close}>{label}</Link>)}
          <Link className="button button--small" to="/#pilot" onClick={close}>Discuss Your Workflow</Link>
        </div>
      </nav>
    </header>
  );
};

export default SiteHeader;
